import styled from 'styled-components';
import { theme, palette } from 'styled-tools';

export const Badge = styled.div`
  font-size: ${theme('fontSize.xxs')};
  font-weight: bold;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  padding: 6px 20px;
  margin: 0 8px 10px 0;
  color: white;
  background-color: ${(properties) => palette(properties.color)};
  border-radius: ${theme('borderRadius.sm')};
  transform: scale(1);
  transition: ${theme('transition')};
  ${theme('components.StatusBadge')}
`;
